import React from 'react';
import { LinkType } from '../../../utils/analytics/types';
import { getUrlWithAtlOrigin } from '../../../utils/getUrlWithAtlOrigin';
import { useOriginId } from '../../notifications-context/main';
import { TruncatedText } from '../../truncated-text';
import { Icon, Link } from './styled';
function Entity(_ref) {
  var text = _ref.text,
    entity = _ref.entity,
    onClick = _ref.onClick;
  var link = entity.link,
    icon = entity.icon;
  var originId = useOriginId();
  var handleClick = function handleClick(clickType) {
    return function (event) {
      if (link) {
        onClick(LinkType.ENTITY, clickType, event);
      }
    };
  };
  return /*#__PURE__*/React.createElement(Link
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
  , {
    className: "notification-list__item-entity-link",
    href: getUrlWithAtlOrigin(link === null || link === void 0 ? void 0 : link.url, originId),
    onClick: handleClick('left'),
    onAuxClick: handleClick('middle'),
    onContextMenu: handleClick('right'),
    "data-testid": "notification-item-entity-link"
  }, icon && /*#__PURE__*/React.createElement(Icon, {
    src: icon.url,
    "aria-hidden": true,
    "data-testid": "notification-item-entity-icon"
  }), /*#__PURE__*/React.createElement(TruncatedText, {
    text: text,
    clamp: 2
  }));
}
export default Entity;